import React, { Component } from 'react';
import { ref as storageRef, uploadBytesResumable } from 'firebase/storage';

class ModernFileUploader extends Component {
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
  }

  handleFileChange = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    // Handle multiple files if needed
    Array.from(files).forEach((file) => {
      this.uploadFile(file);
    });
  }

  uploadFile = (file) => {
    if (this.props.onUploadStart) {
      this.props.onUploadStart();
    }

    // Generate random filename if needed
    let filename = file.name;
    if (this.props.randomizeFilename) {
      const extension = filename.split('.').pop();
      filename = `${Date.now()}_${Math.random().toString(36).substring(7)}.${extension}`;
    }

    // Create storage reference
    // Use storage and path props (cleaner API)
    const storage = this.props.storage;
    const path = this.props.path || 'images';
    const fileRef = storageRef(storage, `${path}/${filename}`);

    // Upload file
    const uploadTask = uploadBytesResumable(fileRef, file);

    // Monitor upload progress
    uploadTask.on('state_changed',
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        if (this.props.onProgress) {
          this.props.onProgress(progress);
        }
      },
      (error) => {
        if (this.props.onUploadError) {
          this.props.onUploadError(error);
        }
      },
      async () => {
        // Upload completed successfully
        try {
          // Get download URL (optional, but useful)
          // const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          
          if (this.props.onUploadSuccess) {
            this.props.onUploadSuccess(filename);
          }
        } catch (error) {
          if (this.props.onUploadError) {
            this.props.onUploadError(error);
          }
        }
      }
    );
  }

  render() {
    const { accept, name, hidden, multiple, children } = this.props;

    return (
      <input
        ref={this.fileInputRef}
        type="file"
        accept={accept}
        name={name}
        style={hidden ? { display: 'none' } : {}}
        multiple={multiple}
        onChange={this.handleFileChange}
      />
    );
  }
}

export default ModernFileUploader;

